import { call, put, takeLatest } from 'redux-saga/effects';

import * as galleryActions from './galleryActions.js';
import { updateGalleryApiCall } from './galleryAPI.js';

function* updateGallerySaga({ payload }) {
  try {
    const { data } = yield call(updateGalleryApiCall, payload);
    yield put(galleryActions.galleryUpdateStore(data));
  } catch (error) {
    yield put(galleryActions.galleryUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* galleryWatcher() {
  yield takeLatest(galleryActions.galleryUpdateRequest.type, updateGallerySaga);
}
